import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, TitleWithText } from '@uncinc/uncinc-react-kitchen-sink';

import { Button, ProjectMap } from '../../../components';
import type { MapType } from '../../../components/ProjectMap/types';
import { PROJECT_TYPE_DAY_PROGRAM, PROJECT_TYPE_SCHOOL } from '../../../config/constants';
import type { ParagraphMap as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphDowloadsProps {
  entity: ImmutableEntity<Type>;
  fluid?: boolean;
}

const ParagraphMap: React.FC<ParagraphDowloadsProps> = ({ entity, fluid = false }) => {
  const paragraph = entity.toJS();
  const { t } = useTranslation();

  const uuid = paragraph.uuid[0].value;
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;
  const link = paragraph.field_link[0];
  const type = (
    paragraph.field_project_type?.[0]?.entity?.name[0].value || PROJECT_TYPE_SCHOOL
  ) as MapType;
  const hidePopup = type === PROJECT_TYPE_DAY_PROGRAM;

  const classes = c('ParagraphMap', type, { hidePopup });

  return (
    <div id={uuid} className={classes}>
      <Container>
        <div className="row">
          {(title || body || link) && (
            <div className="col-md-9 col-lg-6 mb-16 mb-md-8 mb-lg-12">
              {title
                ? <TitleWithText title={title} text={body} />
                : <h2 className="u-sr-only">{t('components.map.title')}</h2>}
              {link && (
                <Button
                  className="mb-6 mb-md-0"
                  type="text"
                  icon="chevron_right"
                  href={link.alias || link.uri}
                >
                  {link.title}
                </Button>
              )}
            </div>
          )}
        </div>
      </Container>

      <Container fluid={fluid} className={fluid ? 'p-0' : ''}>
        <div className={`row${fluid ? ' no-gutters' : ''}`}>
          <div className="col-12">
            <ProjectMap
              mapType={type}
              hidePopup={hidePopup}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphMap;
